import React from "react";
import { motion } from "framer-motion";
import backgroundImage from "../images/piano.jpg";

const SignUpCTA = () => {
  const backgroundVariant = {
    animate: {
      scale: [1, 1.08, 1],
      transition: { duration: 18, repeat: Infinity, ease: "easeInOut" },
    },
  };

  return (
    <section className="relative overflow-hidden bg-ink px-6 py-24 text-white sm:px-8">
      {/* Slow zooming background */}
      <motion.div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImage})` }}
        variants={backgroundVariant}
        animate="animate"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-ink/90 via-ink/75 to-ink/85" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-3xl text-center">
        <motion.span
          className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-semibold uppercase tracking-wider text-brand-300 backdrop-blur"
          initial={{ opacity: 0, y: -12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Free Trial Class
        </motion.span>

        <motion.h2
          className="mt-6 font-display text-4xl font-bold md:text-5xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Discover the Music in You
        </motion.h2>

        <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-200 md:text-xl">
          Join us for a journey of musical excellence. Experience our free trial
          class and ignite your passion for music!
        </p>

        <motion.a
          href="/contact-us"
          className="btn-primary mt-8"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Book a Free Trial
        </motion.a>
      </div>
    </section>
  );
};

export default SignUpCTA;
